import { request } from '@/shared/api/request'

export const getEcd = (externalId) => {
	return request({ url: `/colcontract/ecd/getEcd/${externalId}`, method: 'GET' })
}
